/**
 * Agents Module - AgentDetail Page
 * 
 * Detalle y configuración de un agente
 */
export default function AgentDetail() {
  return (
    <div className="px-4 py-6 sm:px-0">
      <h1 className="text-3xl font-bold text-tf-text mb-6">Detalle del Agente</h1>
      <div className="bg-tf-bg-card shadow rounded-lg p-6">
        <p className="text-tf-text-muted">Configuración del agente - En desarrollo</p>
      </div>
    </div>
  )
}













